import { render } from "./leaderboard-table.vue?vue&type=template&id=2406b893&lang=pug"
import script from "./leaderboard-table.vue?vue&type=script&lang=js"
export * from "./leaderboard-table.vue?vue&type=script&lang=js"

import "./leaderboard-table.vue?vue&type=style&index=0&id=2406b893&lang=sass"

import exportComponent from "/builds/WebServers/festival/leaderboards/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__